import "lib-flexible";
import Vue from 'vue'
import App from './App.vue'
import { router } from './router';
import {Lazyload} from 'vant';
import VueCookies from 'vue-cookies'
import hls from 'videojs-contrib-hls'
import VideoPlayer from 'vue-video-player';
import store from '@/store'

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import './style/iconfont.css'
import $ from 'jquery'
// import Navigation from 'vue-navigation'
Vue.config.ignoredElements =[
  'wx-open-audio',
  'wx-open-subscribe',
]

// import './mock/index';

import {util} from './utils/util'

Vue.prototype.util = util;
Vue.prototype.$ = $;
Vue.config.productionTip = false;
Vue.prototype.$EventBus = new Vue()


new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App),
}).$mount('#app')
// Vue.use(Navigation,{router});
Vue.use(Lazyload);
Vue.use(hls)
Vue.use(VideoPlayer);
Vue.use(VueCookies);
Vue.use(VueCookies);
